import {Service} from '@angular/core';

@Service()
export class InputService {
    public isClickEvent(pointerEvent: PointerEvent): boolean {
        // .detail returns the amount of clicks and 0 means that it is not a click
        return pointerEvent.type === 'click' && pointerEvent.detail >= 1;
    }

    public isEnterKeyPressed(keyboardEvent: KeyboardEvent): boolean {
        return this.isGivenKeyPressed(keyboardEvent, 'Enter', 13);
    }

    public isEscapeKeyPressed(keyboardEvent: KeyboardEvent): boolean {
        return this.isGivenKeyPressed(keyboardEvent, 'Escape', 27);
    }

    public isSpaceKeyPressed(keyboardEvent: KeyboardEvent): boolean {
        return this.isGivenKeyPressed(keyboardEvent, 'Space', 32);
    }

    public isGivenKeyPressed(keyboardEvent: KeyboardEvent, code: string, keyCode: number, onKeyDown: boolean = true, onKeyUp: boolean = false): boolean {
        if ((keyboardEvent.type === 'keyup' && !onKeyUp) || (keyboardEvent.type === 'keydown' && !onKeyDown)) {
            return false;
        }

        // We need .keyCode as a fallback, due to a partial support of .code in Chrome for Android (09.10.2026)
        return (keyboardEvent.code !== undefined && keyboardEvent.code === code) ||
            (keyboardEvent.keyCode !== undefined && keyboardEvent.keyCode === keyCode);
    }
}
